/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddUserReviewInviteCommand } from '../models/add-user-review-invite-command';
import { AddressView } from '../models/address-view';
import { EmployerView } from '../models/employer-view';
import { HouseholdMemberView } from '../models/household-member-view';
import { ProfileLiteView } from '../models/profile-lite-view';
import { ProfileSearchRequestView } from '../models/profile-search-request-view';
import { ProfileSearchResultView } from '../models/profile-search-result-view';
import { ProfileView } from '../models/profile-view';
import { ReferenceView } from '../models/reference-view';
import { WebLinkView } from '../models/web-link-view';

@Injectable({
  providedIn: 'root',
})
export class ProfileService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getMyProfileLite
   */
  static readonly GetMyProfileLitePath = '/api/Profile/GetMyProfileLite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyProfileLite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyProfileLite$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ProfileLiteView>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.GetMyProfileLitePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileLiteView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMyProfileLite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyProfileLite(params?: {
    context?: HttpContext
  }
): Observable<ProfileLiteView> {

    return this.getMyProfileLite$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileLiteView>) => r.body as ProfileLiteView)
    );
  }

  /**
   * Path part for operation getProfileLite
   */
  static readonly GetProfileLitePath = '/api/Profile/GetProfileLite/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileLite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileLite$Response(params: {
    userId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ProfileLiteView>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.GetProfileLitePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileLiteView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProfileLite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileLite(params: {
    userId: string;
    context?: HttpContext
  }
): Observable<ProfileLiteView> {

    return this.getProfileLite$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileLiteView>) => r.body as ProfileLiteView)
    );
  }

  /**
   * Path part for operation profileSearch
   */
  static readonly ProfileSearchPath = '/api/Profile/ProfileSearch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileSearch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  profileSearch$Response(params?: {
    context?: HttpContext
    body?: ProfileSearchRequestView
  }
): Observable<StrictHttpResponse<ProfileSearchResultView>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.ProfileSearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileSearchResultView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `profileSearch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  profileSearch(params?: {
    context?: HttpContext
    body?: ProfileSearchRequestView
  }
): Observable<ProfileSearchResultView> {

    return this.profileSearch$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileSearchResultView>) => r.body as ProfileSearchResultView)
    );
  }

  /**
   * Path part for operation getProfile
   */
  static readonly GetProfilePath = '/api/Profile/GetProfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfile$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ProfileView>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.GetProfilePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfile(params?: {
    context?: HttpContext
  }
): Observable<ProfileView> {

    return this.getProfile$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileView>) => r.body as ProfileView)
    );
  }

  /**
   * Path part for operation getProfileById
   */
  static readonly GetProfileByIdPath = '/api/Profile/GetProfileById/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileById$Response(params: {
    userId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ProfileView>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.GetProfileByIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProfileById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileById(params: {
    userId: string;
    context?: HttpContext
  }
): Observable<ProfileView> {

    return this.getProfileById$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileView>) => r.body as ProfileView)
    );
  }

  /**
   * Path part for operation updateProfile
   */
  static readonly UpdateProfilePath = '/api/Profile/UpdateProfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProfile$Response(params?: {
    context?: HttpContext
    body?: ProfileView
  }
): Observable<StrictHttpResponse<ProfileView>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.UpdateProfilePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProfile(params?: {
    context?: HttpContext
    body?: ProfileView
  }
): Observable<ProfileView> {

    return this.updateProfile$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileView>) => r.body as ProfileView)
    );
  }

  /**
   * Path part for operation updateReferences
   */
  static readonly UpdateReferencesPath = '/api/Profile/UpdateReferences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateReferences()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateReferences$Response(params?: {
    context?: HttpContext
    body?: Array<ReferenceView>
  }
): Observable<StrictHttpResponse<Array<ReferenceView>>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.UpdateReferencesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReferenceView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateReferences$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateReferences(params?: {
    context?: HttpContext
    body?: Array<ReferenceView>
  }
): Observable<Array<ReferenceView>> {

    return this.updateReferences$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReferenceView>>) => r.body as Array<ReferenceView>)
    );
  }

  /**
   * Path part for operation updateAddresses
   */
  static readonly UpdateAddressesPath = '/api/Profile/UpdateAddresses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAddresses()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAddresses$Response(params?: {
    context?: HttpContext
    body?: Array<AddressView>
  }
): Observable<StrictHttpResponse<Array<AddressView>>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.UpdateAddressesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AddressView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAddresses$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAddresses(params?: {
    context?: HttpContext
    body?: Array<AddressView>
  }
): Observable<Array<AddressView>> {

    return this.updateAddresses$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AddressView>>) => r.body as Array<AddressView>)
    );
  }

  /**
   * Path part for operation updateEmployers
   */
  static readonly UpdateEmployersPath = '/api/Profile/UpdateEmployers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEmployers()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEmployers$Response(params?: {
    context?: HttpContext
    body?: Array<EmployerView>
  }
): Observable<StrictHttpResponse<Array<EmployerView>>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.UpdateEmployersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EmployerView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateEmployers$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEmployers(params?: {
    context?: HttpContext
    body?: Array<EmployerView>
  }
): Observable<Array<EmployerView>> {

    return this.updateEmployers$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EmployerView>>) => r.body as Array<EmployerView>)
    );
  }

  /**
   * Path part for operation updateWebLinks
   */
  static readonly UpdateWebLinksPath = '/api/Profile/UpdateWebLinks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWebLinks()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWebLinks$Response(params?: {
    context?: HttpContext
    body?: Array<WebLinkView>
  }
): Observable<StrictHttpResponse<Array<WebLinkView>>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.UpdateWebLinksPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WebLinkView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateWebLinks$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWebLinks(params?: {
    context?: HttpContext
    body?: Array<WebLinkView>
  }
): Observable<Array<WebLinkView>> {

    return this.updateWebLinks$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WebLinkView>>) => r.body as Array<WebLinkView>)
    );
  }

  /**
   * Path part for operation updateHouseholdMembers
   */
  static readonly UpdateHouseholdMembersPath = '/api/Profile/UpdateHouseholdMembers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateHouseholdMembers()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateHouseholdMembers$Response(params?: {
    context?: HttpContext
    body?: Array<HouseholdMemberView>
  }
): Observable<StrictHttpResponse<Array<HouseholdMemberView>>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.UpdateHouseholdMembersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HouseholdMemberView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateHouseholdMembers$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateHouseholdMembers(params?: {
    context?: HttpContext
    body?: Array<HouseholdMemberView>
  }
): Observable<Array<HouseholdMemberView>> {

    return this.updateHouseholdMembers$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HouseholdMemberView>>) => r.body as Array<HouseholdMemberView>)
    );
  }

  /**
   * Path part for operation addUserReviewInvite
   */
  static readonly AddUserReviewInvitePath = '/api/Profile/AddUserReviewInvite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addUserReviewInvite()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addUserReviewInvite$Response(params?: {
    context?: HttpContext
    body?: AddUserReviewInviteCommand
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.AddUserReviewInvitePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addUserReviewInvite$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addUserReviewInvite(params?: {
    context?: HttpContext
    body?: AddUserReviewInviteCommand
  }
): Observable<void> {

    return this.addUserReviewInvite$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
